import Debug from 'debug';
const debug = Debug('controllers:ResourceController');

class ResourceController {
  constructor(model) {
    if (!ResourceController._instance) {
      this.model = model;
      this.dailyEffects = [];
      ResourceController._instance = this;
    } else {
      ResourceController._instance.setModel(model);
    }
    return ResourceController._instance;
  }

  static instance(resourcesModel) {
    if (!ResourceController._instance) {
      ResourceController._instance = new ResourceController(resourcesModel);
    } else if (resourcesModel) {
      ResourceController._instance.setModel(resourcesModel);
    }
    return ResourceController._instance;
  }

  setModel(model) {
    this.model = model;
  }

  setCallbacks(callbackList) {
    this.onChange = (index, oldValue, newValue, context) => {
      callbackList.forEach(callback => callback(index, oldValue, newValue, context));
    };
  }

  delta(resources, context) {
    Object.keys(resources).forEach(res => {
      const resource = this.model.attribs[res] || this.model.items[res];
      const oldValue = resource.value;
      let newValue = oldValue;

      // Calculate new value based on the type of resource change
      // Similar logic as in your original `delta` method

      resource.value = newValue;
      this.onChange(resource.index, oldValue, newValue, context);
    });
  }

  /**
   * A new run gets a new Party, and with it a new progression at level zero — but this is a
   * module singleton, so `dailyEffects` is only ever emptied by the constructor, which runs
   * once for the life of the page. Without this a man who died a Foreman came back an amateur
   * still drawing a foreman's daily pay.
   *
   * The towns are not reset with the party (GameContext keeps `political` across a run), so
   * what they still owe is put back by Political.restoreControl after this.
   */
  resetDailyEffects() {
    debug('clearing daily effects', this.dailyEffects.length);
    this.dailyEffects = [];
  }

  registerAction(action) {
    if (!action) return;
    if (action.type) {
      // replace the action if it already exists
      const index = this.dailyEffects.findIndex(a => a.type === action.type);
      if (index >= 0) {
        debug('replacing action', action.type, action.effects());
        this.dailyEffects[index] = action;
        return;
      }
    }
    this.dailyEffects.push(action);
  }

  getDailyEffects(resource, gameState) {
    // Calculate daily effects based on the resources
    let effect = 0;
    this.dailyEffects.forEach(action => {
      if (!action.effects || !action.effects.resources) return;
      effect += action.effects().resources[resource] || 0;
    });

    if (!gameState) return Math.round(effect * 10) / 10;

    const isInCity = gameState.party.city;
    const consumption = gameState.party.caravan?.consumption(isInCity)[resource] || 0;
    effect -= consumption;

    return Math.round(effect * 10) / 10;
  }

  isVisible(resources, resource) {
    return resources.includes(resource.index);
  }
}

export default ResourceController;
